import { useQuery } from '@apollo/client';
import React from 'react';
import { provisionPostPolicyCheck } from './provisionAccessCheck';
import * as styles from './ProvisionEntitySearchPostPill.module.scss';
import SVGIcon from '../../components/SVGIcon';
import { gql } from '../../graphql/generated/gql';
import alertIcon from '../../icons/non-prefilled/16x16/alert.svg';
import PostPill from '../../post/PostPill';
import { PostPolicyAction } from '../../post/postPolicyCheck';
import omitNonTopics from '../../utils/omitNonTopics';

const POST_QUERY = gql(/** @complexity 137 */ `
  query ProvisionEntitySearchPostPill($id: ID!) {
    post(id: $id) {
      ...PostPill_post
      ...provisionPostPolicyCheck_post
      topics {
        id
        ... on Topic {
          name
        }
      }
    }
  }
`);

type PostPillProps = React.ComponentProps<typeof PostPill>;
type ProvisionEntitySearchPostPillProps = Omit<
  PostPillProps,
  'tooltip' | 'post'
> & {
  post: PostPillProps['post'] & { id: string };
  provision: Parameters<typeof provisionPostPolicyCheck>[2];
};

const ProvisionEntitySearchPostPill = ({
  provision,
  ...props
}: ProvisionEntitySearchPostPillProps) => {
  const { data } = useQuery(POST_QUERY, {
    variables: { id: props.post.id },
  });
  const fullPost = data?.post;
  let permissionProps = {};

  if (
    fullPost &&
    !provisionPostPolicyCheck(PostPolicyAction.ViewPost, fullPost, provision)
  ) {
    const postTopics = omitNonTopics(fullPost.topics ?? []);
    const postTopicNames = postTopics.map((t) => t.name).join(', ');

    permissionProps = {
      icon: (
        <SVGIcon className={styles.icon} inline>
          {alertIcon}
        </SVGIcon>
      ),
      tooltip:
        postTopics.length > 0
          ? `Users will not have access\nto this post unless they\nare added as a member of\none of its topics: ${postTopicNames}`
          : 'Users will not have access\nto this post unless it\nis added to a topic that\nthey have access to.',
    };
  }
  return <PostPill {...props} {...permissionProps} />;
};

export default ProvisionEntitySearchPostPill;
